// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3R5BJ","footer":"ModalUpdate_footer__1ov6m"};